import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-text-section">
          <h1 className="hero-title">
            <span>RAPID INTEGRATED PLANNING</span>
            <span className="title-accent">AND ENGINEERING (RIPE)</span>
          </h1>

          <div className="hero-description">
            <div className="description-card">
              <h3>Transforming Infrastructure Planning</h3>
              <p>
                RIPE harnesses the power of the AI, immersive visuals and
                simulations to revolutionize complex, large-scale infrastructure
                planning. Our integrated platform transforms slow, fragmented
                workflows into fast, connected, insight-driven digital planning
                that's mission-ready from day one.
              </p>
              <p>
                Built through strategic partnerships with military engineering
                leaders, RIPE combines trusted data, immersive design tools, and
                real-time scenario modeling to help teams compress planning
                cycles by up to 75%.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-background">
        <div className="hero-gradient"></div>
        <video
          className="hero-bg-video"
          autoPlay
          loop
          muted
          playsInline
          poster="/drone-coastal-hero-better.jpg"
        >
          <source
            src="/artificial-intelligence-futuristic-virtual-globe-h-2025-08-29-10-37-43-utc.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </section>
  );
};

export default Hero;
